import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { getEnvironment } from 'src/env/env';

export const usePHIndentity = () => {
  const { data: accounts } = useGetAccountsQuery();
  const { data: userInfo } = useGetUsersMeQuery();

  useEffect(() => {
    if (posthog && accounts && userInfo) {
      (async () => {
        const env = await getEnvironment();

        if (env.ENVIRONMENT === 'PROD') {
          posthog?.identify((userInfo as any).id, {
            email: (userInfo as any).email,
            account_id: (accounts as any).id,
          });
        }
      })();
    }
  }, [posthog, accounts, userInfo]);
};
